import { render, staticRenderFns } from "./SMSGateway.vue?vue&type=template&id=b49d91e0"
import script from "./SMSGateway.vue?vue&type=script&lang=js"
export * from "./SMSGateway.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports